import "./CalendarButton.scss";

const CalenderButton = (props: any) => {
  return (
    <div className="calendar-btn" onClick={props.onClick}>
      <div
        className={
          "margin-right-20 base bolder " +
          (props.selected ? "selected" : "border")
        }
      >
        {props.label}
      </div>
    </div>
  );
};

export default CalenderButton;
